// Configuration utility for white-labeling and environment variables
import { Device } from '@capacitor/device';

// Content creator information
export const getContentCreator = () => {
  return {
    name: import.meta.env.VITE_CONTENT_CREATOR_NAME || 'Rabbi Wechter',
    title: import.meta.env.VITE_CONTENT_CREATOR_TITLE || 'Rabbi',
    organization: import.meta.env.VITE_ORGANIZATION_NAME || 'Mann Technologies LTD',
    country: import.meta.env.VITE_ORGANIZATION_COUNTRY || 'Canada',
  };
};

// App URLs
export const getAppUrls = () => {
  // For web, get the current domain
  const currentDomain = window.location.origin;
  
  // For native apps (Capacitor), we need to use environment variables
  // as window.location.origin will be a file:// URL
  return {
    website: import.meta.env.VITE_APP_WEBSITE_URL || currentDomain,
    androidApp: import.meta.env.VITE_ANDROID_APP_URL || 'Google Play Store URL',
    iosApp: import.meta.env.VITE_IOS_APP_URL || 'App Store URL',
    privacyEmail: import.meta.env.VITE_PRIVACY_EMAIL || 'privacy@manntechnologies.com',
  };
};

// Check if running in a Capacitor environment
export const isCapacitorApp = async (): Promise<boolean> => {
  try {
    const info = await Device.getInfo();
    return info.platform !== 'web';
  } catch (error) {
    console.error('Error checking platform:', error);
    return false;
  }
};

// Get the appropriate app URL based on platform
export const getAppUrl = async (): Promise<string> => {
  const isNative = await isCapacitorApp();
  
  if (!isNative) {
    return getAppUrls().website;
  }
  
  try {
    // For Capacitor apps, determine if Android or iOS
    const info = await Device.getInfo();
    if (info.platform === 'android') {
      return getAppUrls().androidApp;
    } else if (info.platform === 'ios') {
      return getAppUrls().iosApp;
    }
  } catch (error) {
    console.error('Error getting device info:', error);
  }
  
  // Fallback to website
  return getAppUrls().website;
}; 